module.exports = __webpack_public_path__ + "static/media/about-17.63f3baa1.png";